"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Container_1 = require("../../components/Container");
var Padder_1 = require("../../components/Padder");
var ConfigProvider_1 = __importDefault(require("../../providers/ConfigProvider"));
var utils_1 = require("../PristupnostCookies/utils");
var DatovaSadaTlumocnici_1 = __importDefault(require("./DatovaSadaTlumocnici"));
var DatovaSadaZnalci_1 = __importDefault(require("./DatovaSadaZnalci"));
var OpenDataPage = function () {
    return (react_1.default.createElement(Container_1.Container, { title: "Otev\u0159en\u00E1 data znalc\u016F, tlumo\u010Dn\u00EDk\u016F a\u00A0p\u0159ekladatel\u016F", linkTo: "/" },
        react_1.default.createElement(Padder_1.Padder, null,
            react_1.default.createElement(utils_1.H2, null, "\u00DAvod"),
            react_1.default.createElement(DatovaSadaZnalci_1.default, null),
            react_1.default.createElement(ConfigProvider_1.default, { typ: "tlumocnik" },
                react_1.default.createElement(DatovaSadaTlumocnici_1.default, null)))));
};
exports.default = OpenDataPage;
